import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"
import {
  BackofficeRestMutations,
  CancelAccountRegistrationPayload,
} from "@/api/backofficeRest/mutations"
import { CancelAccountResponse } from "@/api/backofficeRest/generated/model"
import { useCurrentAccountStore } from "@/stores/currentAccount"
import { ICancelAccountForm } from "./CancelAccountMutator.types"

export interface ICancelAccountMutator {
  cancelAccount(): MutationResult<ICancelAccountForm, CancelAccountResponse>
}

class CancelAccountMutatorClass implements ICancelAccountMutator {
  cancelAccount(): MutationResult<ICancelAccountForm, CancelAccountResponse> {
    return useMutation({
      ...BackofficeRestMutations.account.cancelRegistration(),
      serializerFn: (
        data: ICancelAccountForm,
      ): CancelAccountRegistrationPayload => {
        const billingAccountId = useCurrentAccountStore().coreId.data
        if (!billingAccountId) throw new Error("Missing coreId")
        return {
          billingAccountId,
          body: {
            reason: data.reason,
          },
        }
      },
    })
  }
}

export const CancelAccountMutator = new CancelAccountMutatorClass()
